import { useTheme } from '@mui/material/styles';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            borderRadius: '10px',
            background: 'linear-gradient(90deg, rgba(29,56,144,1) 0%, rgba(46,85,219,1) 100%)',
            padding: theme.spacing(3),
            minHeight: '14rem',
            maxWidth: '25rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            marginBottom: theme.spacing(1),
        },
        mastercard: {
            background: 'linear-gradient(90deg, rgba(21,26,31,1) 0%, rgba(68,77,87,1) 100%)',
        },
        visa: {
            background: 'linear-gradient(90deg, rgba(29,56,144,1) 0%, rgba(46,85,219,1) 100%)',
        },
        other: {
            background: theme.palette.secondary.dark,
        },
        brand: {
            width: '5rem',
            marginTop: theme.spacing(1),
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        info: {
            color: theme.palette.common.white,
        },
        otherbrand: {
            fontWeight: 900,
            color: theme.palette.common.white,
        },
        number: {
            marginBottom: theme.spacing(1),
        },
        changeCard: {
            color: theme.palette.common.white,
        },
    };
};
